<template>
  <!-- 页面 -->
  <div id="u_r_V7IP16" :class="[curLang]" class="u_r_V7IP16 route-page"  ><div id="u_c_0CW117"  :style="`background-color:${ pageData.needBg ? pageData.hostInfo[pageData.curHost].bgColor : 'transparent' }`" :class="[`normal`,`u_c_0CW117`]" ><div id="u_c_290K18"  :style="`color:${ pageData.linkTitleColor }`" :class="[`normal title`,`u_c_290K18`]" >{{`${ langData.tokenTip }`}}</div><div id="u_c_QVE151"  :class="[`normal step-img`,`u_c_QVE151`]" ><img id="u_c_3I1552"  :src="`https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/08/16608043509764.png`" :class="[`normal`,`u_c_3I1552`]" /><div id="u_c_TV5453"  :style="`color:${ pageData.hostInfo[pageData.curHost].titleColor }`" :class="[`normal`,`u_c_TV5453`]" >{{`${ langData.tokenKey }`}}</div></div><div id="u_c_XL6I21"  :style="`color:${ pageData.linkTxtColor }`" :class="[`normal txt`,`u_c_XL6I21`]" >{{`${ langData.tokenIntro1 }`}}</div><div id="u_c_FEJX23"  :style="`color:${ pageData.linkTxtColor }`" :class="[`normal txt`,`u_c_FEJX23`]" >{{`${ langData.tokenIntro2 }`}}</div><div id="u_c_4OL627"  :style="`color:${ pageData.linkTitleColor }`" :class="[`normal title`,`u_c_4OL627`]" >{{`${ langData.howToGetToken }`}}</div><u_c_ZOJP17></u_c_ZOJP17><u_c_UA4817></u_c_UA4817><u_c_D0C4226></u_c_D0C4226><u_c_34OJ207></u_c_34OJ207><u_c_85BV188></u_c_85BV188><u_c_FIJ7169></u_c_FIJ7169><u_c_ZJTY17></u_c_ZJTY17><u_c_8NIE18></u_c_8NIE18><u_c_11LA74></u_c_11LA74><u_c_A4Y118></u_c_A4Y118><u_c_8WAA18></u_c_8WAA18><u_c_W0TN93></u_c_W0TN93><u_c_5066112></u_c_5066112><u_c_2XZP131></u_c_2XZP131><u_c_17ZY150></u_c_17ZY150><u_c_4S3E55></u_c_4S3E55><u_c_98U018></u_c_98U018><u_c_1VIZ36></u_c_1VIZ36></div></div>
  </template>
<script>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import Language from "@/hooks/language.js";
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import u_c_ZOJP17 from "@/components/u_c_ZOJP17.vue";import u_c_UA4817 from "@/components/u_c_UA4817.vue";import u_c_34OJ207 from "@/components/u_c_34OJ207.vue";import u_c_85BV188 from "@/components/u_c_85BV188.vue";import u_c_FIJ7169 from "@/components/u_c_FIJ7169.vue";import u_c_ZJTY17 from "@/components/u_c_ZJTY17.vue";import u_c_8NIE18 from "@/components/u_c_8NIE18.vue";import u_c_11LA74 from "@/components/u_c_11LA74.vue";import u_c_A4Y118 from "@/components/u_c_A4Y118.vue";import u_c_8WAA18 from "@/components/u_c_8WAA18.vue";import u_c_W0TN93 from "@/components/u_c_W0TN93.vue";import u_c_5066112 from "@/components/u_c_5066112.vue";import u_c_2XZP131 from "@/components/u_c_2XZP131.vue";import u_c_17ZY150 from "@/components/u_c_17ZY150.vue";import u_c_4S3E55 from "@/components/u_c_4S3E55.vue";import u_c_98U018 from "@/components/u_c_98U018.vue";import u_c_1VIZ36 from "@/components/u_c_1VIZ36.vue"
export default {
  name: 'router_V7IP16',
  components: {u_c_ZOJP17,u_c_UA4817,u_c_34OJ207,u_c_85BV188,u_c_FIJ7169,u_c_ZJTY17,u_c_8NIE18,u_c_11LA74,u_c_A4Y118,u_c_8WAA18,u_c_W0TN93,u_c_5066112,u_c_2XZP131,u_c_17ZY150,u_c_4S3E55,u_c_98U018,u_c_1VIZ36,},
  setup(){
    const { curLang, getLangTxt, langData } = Language();
    const compData = {};
    const ROUTER_DATA_LANG = {"zh-CN":{},"zh-TW":{},"en-US":{},"ja-JP":{},"ko-KR":{},"th-TH":{},"vi-VN":{},"de-DE":{},"fr-FR":{},"ru-RU":{},"es-ES":{},"pt-PT":{},"it-IT":{},"tr-TR":{},"pl-PL":{},"id-ID":{},"ar-SA":{},"default":{}};
    const routerData = reactive(ROUTER_DATA_LANG[curLang] || ROUTER_DATA_LANG['en-US']||{});
    provide("routerData", routerData);
    const pageData = inject("pageData", {});
    const router = Router();
    let pagePlatform = "global"

    // 自定义setup - 开始
    
    // 自定义setup - 结束
    return {pageData,routerData,langData,curLang}
  }
}
</script>
<style lang="scss" scoped>

.u_c_0CW117.normal{
position:relative;
box-sizing:border-box;
padding:4.27vw 7.73vw;

}

.u_c_0CW117.normal .title{
font-size:4.27vw;
color:#414141;
margin:8.53vw auto 4.27vw;
text-align:center;
font-weight:bold;

}

.u_c_0CW117.normal .txt{
font-size:2.67vw;
color:#707070;
line-height:150%;

}

.u_c_290K18.normal{
position:relative;

}

.u_c_QVE151.normal{
position:relative;
width:100%;
background-color:white;

}

.u_c_3I1552.normal{
position:relative;
width:100%;

}

.u_c_TV5453.normal{
position:absolute;
font-size:3.20vw;
top:2.67vw;
left:2.67vw;
font-weight:bold;

}

.u_c_XL6I21.normal{
position:relative;

}

.u_c_FEJX23.normal{
position:relative;

}

.u_c_4OL627.normal{
position:relative;

}

</style>
